export enum CustomControlMode {
    edit = 'edit',
    read = 'read',
}
